// import Searchbar from "./Searchbar";
// import Button from "./Button";
// import IconButton from "./IconButton";
// import Icon from "../../assets/icons/Icon";
// import { useRef, useState, useEffect } from "react";
// import MobileMenu from "./MobileMenu";
// import PopupModal from "./PopupModal";
// import ExportButton from "./ExportButton";
// import { isMobileView } from "./CommonFunctions";

// const DataViewPage = ({
//   header = {},
//   customHeader,
//   footer = null,
//   title,
//   children,
//   isCompress,
//   iconType,
//   handleRemoveBtnClick,
//   handleOnPrint,
//   hideFooter,
//   handleOnExport,
//   handleOnRefresh,
//   handleOnFilter,
//   subTitle,
//   isFilterActive,
//   handleOnPark,
//   tabs = [],
//   activeTab,
//   onTabChange,
//   handleBack = null,
//   customButtons
// }) => {
//   const {
//     search = {},
//     createButton = {},
//     filterButton = {},
//     options = {},
//   } = header;

//   const [showExportOptions, setShowExportOptions] = useState(false);
//   const [exportSelectedOption, setExportSelectedOption] = useState("");
//   const dropdownRef = useRef(null);
//   const mobileView = isMobileView();
//   const [openMenuDrawer, setOpenMenuDrawer] = useState(false);
//   const [showMobileOptions, setShowMobileOptions] = useState(false);

//   // Count the number of buttons in header
//   const countHeaderButtons = () => {
//     let count = 0;
//     if (handleOnRefresh) count++;
//     if (handleBack) count++;
//     if (handleOnFilter) count++;
//     if (handleOnPrint) count++;
//     if (createButton.createButton) count++;
//     if (handleOnPark) count++;
//     if (options?.option) count++;
//     if (filterButton.filterButton) count++;
//     if (handleOnExport) count++;
//     if (handleRemoveBtnClick) count++;
//     return count;
//   };

//   const hasMultipleButtons = countHeaderButtons() >= 3;
//   const showFloatingButton =
//     mobileView && (hasMultipleButtons || tabs.length > 0);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowExportOptions(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <>
//       <div
//         className={`bg-gray-soft-gradient h-screen flex flex-col overflow-hidden`}
//       >
//         {/* Header */}
//         {header && (
//           <div
//             className={`flex-none ${isCompress && "shadow-[0_6px_12px_rgba(0,0,0,0.15)]"
//               } ${!mobileView && !isCompress && "px-3 pt-3"}`}
//           >
//             <div className="relative z-10">
//               <div
//                 className={`bg-white/60 ${isCompress || mobileView ? "" : "rounded-t-2xl"
//                   } border border-gray-100 p-4`}
//               >
//                 <div className="flex md:flex-row items-start justify-between gap-4">
//                   {/* Left Side - Title and Stats */}
//                   <div>
//                     <h1 className="text-2xl font-bold text-gray-800 flex items-start">
//                       {mobileView && (
//                         <span
//                           className="w-5 mt-1 mr-5 text-(--tab-gray) flex-shrink-0"
//                           onClick={() => {
//                             setOpenMenuDrawer(true);
//                           }}
//                         >
//                           <Icon type={"menu"} />
//                         </span>
//                       )}
//                       {iconType && (
//                         <span className="bg-indigo-100 text-indigo-600 p-2 rounded-lg mr-3 w-8 flex-shrink-0">
//                           <Icon type={iconType} />
//                         </span>
//                       )}
//                       {title}
//                     </h1>
//                     {!isCompress && !mobileView && title && (
//                       <p className="text-gray-500 mt-1 ml-11.5">
//                         {subTitle
//                           ? subTitle
//                           : `Manage and view all your ${title.toLowerCase()}`}
//                       </p>
//                     )}
//                   </div>

//                   {/* Right Side - Search and Actions */}
//                   <div
//                     className={`w-full md:w-auto flex flex-col sm:flex-row ${mobileView ? "px-5" : "gap-5"
//                       }`}
//                   >
//                     {/* Search Bar */}
//                     {!isCompress && !mobileView && customButtons?.length>0 && customButtons?.map((btn, index) => (
//                       <div key={index} className="flex-1">
//                         {btn}
//                       </div>
//                     ))}
//                     {!isCompress && !mobileView && (
//                       <div className={`${mobileView ? "w-full" : "w-sm"} `}>
//                         {search.searchBar && (
//                           <div className="flex space-x-5">
//                             <Searchbar
//                               value={search.value}
//                               onChange={search.onSearchChange}
//                               placeholder={search.placeholder || "Search..."}
//                               handleFilterClick={search.handleFilterClick}
//                               hideFilter={search.hideFilter}
//                               hideRefresh={search.hideRefresh}
//                               handleRefreshClick={search.handleRefreshClick}
//                               isFilterActive={search.isFilterActive}
//                             />
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Tabs for desktop */}
//                     {tabs.length > 0 && !mobileView && (
//                       <div className="flex rounded-lg border border-gray-200 overflow-hidden bg-gray-50 mr-3">
//                         {tabs.map((tab) => (
//                           <button
//                             key={tab.value}
//                             onClick={() => onTabChange(tab.value)}
//                             className={`cursor-pointer px-4 py-2 h-[34px] text-sm font-medium transition-all duration-200 min-w-[90px] ${activeTab === tab.value
//                                 ? "bg-indigo-600 text-white"
//                                 : "bg-transparent text-gray-600 hover:bg-gray-100"
//                               }`}
//                           >
//                             <div className="flex items-center whitespace-nowrap justify-center gap-2">
//                               <span>{tab.label}</span>
//                               {tab.count !== undefined && (
//                                 <span
//                                   className={`px-2 py-0.5 text-xs rounded-full ${activeTab === tab.value
//                                       ? "bg-white text-indigo-600"
//                                       : "bg-gray-200 text-gray-600"
//                                     }`}
//                                 >
//                                   {tab.count}
//                                 </span>
//                               )}
//                             </div>
//                           </button>
//                         ))}
//                       </div>
//                     )}

//                     {/* Filter Button */}
//                     <div className="flex gap-5 ml-auto">
//                       {/* Show only first 2 buttons in mobile view, show all in desktop */}
//                       {!mobileView || !hasMultipleButtons ? (
//                         <>
//                           {handleOnRefresh && (
//                             <IconButton
//                               onClick={handleOnRefresh}
//                               infoText={"Refresh"}
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <Icon type="refresh"></Icon>
//                             </IconButton>
//                           )}
//                           {handleBack && (
//                             <IconButton
//                               onClick={handleBack}
//                               infoText={"Back"}
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <Icon type="remove"></Icon>
//                             </IconButton>
//                           )}
//                           {handleOnFilter && (
//                             <IconButton
//                               onClick={handleOnFilter}
//                               infoText={"filter"}
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <div className="relative">
//                                 <Icon type="filter" />
//                                 {isFilterActive && (
//                                   <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
//                                     <span className="relative flex h-2 w-2">
//                                       <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
//                                       <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
//                                     </span>
//                                   </span>
//                                 )}
//                               </div>
//                             </IconButton>
//                           )}
//                           {handleOnPrint && (
//                             <IconButton
//                               onClick={handleOnPrint}
//                               infoText={"Print"}
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <Icon type="print"></Icon>
//                             </IconButton>
//                           )}
//                           {createButton.createButton && (
//                             <span>
//                               <Button
//                                 type="primary"
//                                 px="px-4"
//                                 onClick={
//                                   createButton.onCreateClick || (() => { })
//                                 }
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   className="h-5 w-5 mr-2"
//                                   fill="none"
//                                   viewBox="0 0 24 24"
//                                   stroke="currentColor"
//                                 >
//                                   <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M12 4v16m8-8H4"
//                                   />
//                                 </svg>
//                                 {createButton.createButtonText}
//                               </Button>
//                             </span>
//                           )}
//                           {handleOnPark && (
//                             <IconButton
//                               onClick={handleOnPark || (() => { })}
//                               label="options"
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                               infoText={"Parked Transaction"}
//                               tooltipWidth={"150px"}
//                             >
//                               <Icon type="parked"></Icon>
//                             </IconButton>
//                           )}
//                           {options?.option && (
//                             <IconButton
//                               onClick={options.onOptionClick || (() => { })}
//                               label="options"
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                               infoText={"Option"}
//                             >
//                               <Icon type="option"></Icon>
//                             </IconButton>
//                           )}
//                           {filterButton.filterButton && (
//                             <IconButton
//                               onClick={filterButton.onFilterClick || (() => { })}
//                               label="help"
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <Icon type="help"></Icon>
//                             </IconButton>
//                           )}
//                           {handleOnExport && (
//                             <ExportButton
//                               onExport={(value) => {
//                                 handleOnExport(value);
//                               }}
//                             />
//                           )}
//                           {handleRemoveBtnClick && (
//                             <span
//                               className="hidden md:block lg:block w-7 p-0 text-right text-(--list-item-gray) hover:text-gray-900 cursor-pointer mt-1.5"
//                               onClick={handleRemoveBtnClick}
//                             >
//                               <Icon type={"remove"} />
//                             </span>
//                           )}
//                         </>
//                       ) : (
//                         // In mobile view with multiple buttons, show only the first 2 buttons
//                         <>
//                           {handleOnRefresh && (
//                             <IconButton
//                               onClick={handleOnRefresh}
//                               infoText={"Refresh"}
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <Icon type="refresh"></Icon>
//                             </IconButton>
//                           )}
//                           {handleOnFilter && (
//                             <IconButton
//                               onClick={handleOnFilter}
//                               infoText={"filter"}
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <div className="relative">
//                                 <Icon type="filter" />
//                                 {isFilterActive && (
//                                   <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
//                                     <span className="relative flex h-2 w-2">
//                                       <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
//                                       <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
//                                     </span>
//                                   </span>
//                                 )}
//                               </div>
//                             </IconButton>
//                           )}

//                           {handleBack && (
//                             <IconButton
//                               onClick={handleBack}
//                               infoText={"Remove"}
//                               bgColor="#F5F5F5"
//                               textColor="#5e5e5e"
//                               newhover={true}
//                             >
//                               <Icon type="remove"></Icon>
//                             </IconButton>
//                           )}
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Search bar for mobile/compress view */}
//                 {(isCompress || mobileView) && (
//                   <div className="mt-5 ">
//                     <div className="mx-1">
//                       {search.searchBar && (
//                         <div className="flex space-x-5">
//                           <Searchbar
//                             value={search.value}
//                             onChange={search.onSearchChange}
//                             placeholder={search.placeholder || "Search..."}
//                             handleFilterClick={search.handleFilterClick}
//                             hideFilter={search.hideFilter}
//                             hideRefresh={search.hideRefresh}
//                             handleRefreshClick={search.handleRefreshClick}
//                             isFilterActive={search.isFilterActive}
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//         {customHeader && <span>{customHeader}</span>}

//         {/* Main Content */}
//         <div
//           className={`flex-grow ${!mobileView && !isCompress && "px-3 "
//             } overflow-hidden `}
//         >
//           {children}

//           {/* Floating button for mobile options */}
//           {
//             showFloatingButton && (
//               <div className="fixed bottom-20 right-6 shadow-lg z-10">
//                 <IconButton
//                   onClick={() => {
//                     setShowMobileOptions(true);
//                     console.log("Floating button clicked");
//                   }}
//                   type="primary"
//                 >
//                   <Icon type="option" />
//                 </IconButton>
//               </div>
//             )
//             // <span
//             //   className="fixed bottom-20 right-6 shadow-lg z-10 roduned-lg p-2 rounded-lg text-white bg-gradient-to-r from-indigo-600 to-purple-600"

//             // >
//             //   <div className="w-5 ">

//             //   </div>
//             // </span>
//           }
//         </div>

//         {/* Footer */}
//         {footer && !mobileView && (
//           <div
//             className={`flex-none ${isCompress ? "shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]" : "px-3"
//               }  mb-3 backdrop-blur-sm `}
//           >
//             {footer}
//           </div>
//         )}

//         {hideFooter && !mobileView && (
//           <div className="flex-none px-3 mb-3 backdrop-blur-sm bg-white/70 p-2  rounded-b-xl border border-gray-100  mx-3"></div>
//         )}
//       </div>

//       {/* Mobile Menu Drawer */}
//       {openMenuDrawer && (
//         <MobileMenu
//           isOpen={openMenuDrawer}
//           onClose={() => setOpenMenuDrawer(false)}
//         />
//       )}

//       {/* Mobile Options Popup */}
//       {showMobileOptions && (
//         <PopupModal setPopUp={setShowMobileOptions} size="" title="Options">
//           <div className="flex flex-col space-y-3">
//             {/* Tabs Section */}
//             {tabs.length > 0 && (
//               <div className="mb-4">
//                 <div className="flex flex-col space-y-2">
//                   {tabs.map((tab) => (
//                     <button
//                       key={tab.value}
//                       onClick={() => {
//                         onTabChange(tab.value);
//                         setShowMobileOptions(false);
//                       }}
//                       className={`cursor-pointer px-4 py-3 text-sm font-medium transition-all duration-200 rounded-lg ${activeTab === tab.value
//                           ? "bg-indigo-600 text-white"
//                           : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                         }`}
//                     >
//                       <div className="flex items-center justify-between">
//                         <span>{tab.label}</span>
//                         {tab.count !== undefined && (
//                           <span
//                             className={`px-2 py-1 text-xs rounded-full ${activeTab === tab.value
//                                 ? "bg-white text-indigo-600"
//                                 : "bg-gray-300 text-gray-600"
//                               }`}
//                           >
//                             {tab.count}
//                           </span>
//                         )}
//                       </div>
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Actions Section */}
//             {!tabs.length > 0 && (
//               <div>
//                 <div className="flex flex-col space-y-2">
//                {customButtons?.length > 0 &&
//   customButtons.map((btn, index) => (
//     <div key={index}>
//       {btn}
//     </div>
//   ))}

//                   {/* Refresh Button */}
//                   {handleOnRefresh && (
//                     <Button
//                       type="secondary"
//                       onClick={() => {
//                         handleOnRefresh();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"refresh"}
//                     >
//                       Refresh
//                     </Button>
//                   )}

//                   {/* Filter Button */}
//                   {handleOnFilter && (
//                     <Button
//                       type="secondary"
//                       onClick={() => {
//                         handleOnFilter();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"filter"}
//                     >
//                       Filter
//                     </Button>
//                   )}

//                   {/* Print Button */}
//                   {handleOnPrint && (
//                     <Button
//                       type="secondary"
//                       onClick={() => {
//                         handleOnPrint();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"print"}
//                     >
//                       Print
//                     </Button>
//                   )}

//                   {/* Create Button */}
//                   {createButton.createButton && (
//                     <Button
//                       type="primary"
//                       onClick={() => {
//                         createButton.onCreateClick();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"add"}
//                     >
//                       {createButton.createButtonText || "New"}
//                     </Button>
//                   )}

//                   {/* Parked Transactions */}
//                   {handleOnPark && (
//                     <Button
//                       type="secondary"
//                       onClick={() => {
//                         handleOnPark();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"parked"}
//                     >
//                       Parked Transactions
//                     </Button>
//                   )}

//                   {/* Options */}
//                   {options?.option && (
//                     <Button
//                       type="secondary"
//                       onClick={() => {
//                         options.onOptionClick();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"option"}
//                     >
//                       Options
//                     </Button>
//                   )}

//                   {/* Help/Filter Button */}
//                   {filterButton.filterButton && (
//                     <Button
//                       type="secondary"
//                       onClick={() => {
//                         filterButton.onFilterClick();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"help"}
//                     >
//                       Help
//                     </Button>
//                   )}

//                   {/* Export Button */}
//                   {handleOnExport && (
//                     <div className="mt-2">
//                       <ExportButton
//                         onExport={(value) => {
//                           handleOnExport(value);
//                           setShowMobileOptions(false);
//                         }}
//                       />
//                     </div>
//                   )}

//                   {/* Remove Button */}
//                   {handleRemoveBtnClick && (
//                     <Button
//                       type="secondary"
//                       onClick={() => {
//                         handleRemoveBtnClick();
//                         setShowMobileOptions(false);
//                       }}
//                       iconType={"remove"}
//                     >
//                       Remove
//                     </Button>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </PopupModal>
//       )}
//     </>
//   );
// };

// export default DataViewPage;

import Searchbar from "./Searchbar";
import Button from "./Button";
import IconButton from "./IconButton";
import Icon from "../../assets/icons/Icon";
import { useRef, useState, useEffect } from "react";
import MobileMenu from "./MobileMenu";
import PopupModal from "./PopupModal";
import ExportButton from "./ExportButton";
import { isMobileView } from "./CommonFunctions";
import Tab from "./Tab";

const DataViewPage = ({
  header = {},
  customHeader,
  footer = null,
  title,
  children,
  isCompress,
  iconType,
  handleRemoveBtnClick,
  handleOnPrint,
  hideFooter,
  handleOnExport,
  handleOnRefresh,
  handleOnFilter,
  subTitle,
  isFilterActive,
  handleOnPark,
  tabs = [],
  activeTab,
  onTabChange,
  handleBack = null,
  customButtons
}) => {
  const {
    search = {},
    createButton = {},
    filterButton = {},
    options = {},
  } = header;

  const [showExportOptions, setShowExportOptions] = useState(false);
  const [exportSelectedOption, setExportSelectedOption] = useState("");
  const dropdownRef = useRef(null);
  const mobileView = isMobileView();
  const [openMenuDrawer, setOpenMenuDrawer] = useState(false);
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);
  const floatingMenuRef = useRef(null);

  // Count the number of buttons in header
  const countHeaderButtons = () => {
    let count = 0;
    // if (handleOnRefresh) count++;
    if (handleBack) count++;
    // if (handleOnFilter) count++;
    if (handleOnPrint) count++;
    if (createButton.createButton) count++;
    if (handleOnPark) count++;
    //if (options?.option) count++;
    if (filterButton.filterButton) count++;
    if (handleOnExport) count++;
    if (handleRemoveBtnClick) count++;
    return count;
  };

  const hasMultipleButtons = countHeaderButtons() >= 1;
  const showFloatingButton = mobileView && hasMultipleButtons ;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowExportOptions(false);
      }
      // Close floating menu when clicking outside
      if (floatingMenuRef.current && !floatingMenuRef.current.contains(event.target)) {
        setShowFloatingMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Floating menu items component
const FloatingMenuItems = () => {
  const menuItems = [];

  // Add custom buttons first
  if (customButtons?.length > 0) {
    customButtons.forEach((btn, index) => {
      menuItems.push(
        <div key={`custom-${index}`} className="w-full">
          {btn}
        </div>
      );
    });
  }

  // Helper function to create menu items with consistent layout
  const createMenuItem = (key, text, iconType, onClick, showActiveDot = false, customColors = null) => (
    <div
      key={key}
      className="w-full flex justify-end items-center px-4 py-3 hover:bg-gray-50 cursor-pointer group gap-4"
      onClick={() => {
        onClick();
        setShowFloatingMenu(false);
      }}
    >
      <span className="font-semibold text-white text-right">{text}</span>
      <div className="relative flex-shrink-0">
        <IconButton 
          bordernone={true}
          bgColor={customColors?.bg || "#8b5cf6"} // Pass custom bg color or default purple
          textColor={customColors?.text || "#ffffff"} // Pass custom text color or default white
          isHoverColor={true}
        >
          <Icon type={iconType} className={iconType === 'refresh' ? 'text-white' : 'text-white'} />
        </IconButton>
        {showActiveDot && (
          <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
            </span>
          </span>
        )}
      </div>
    </div>
  );

  // Add all other buttons with custom colors
  // if (handleOnRefresh) {
  //   menuItems.push(
  //     createMenuItem(
  //       'refresh', 
  //       'Refresh', 
  //       'refresh', 
  //       handleOnRefresh,
  //       false,
  //       {
  //         bg: "#ef4444", // Red background
  //         text: "#ffffff" // White text
  //       }
  //     )
  //   );
  // }
  if (createButton.createButton) {
    menuItems.push(
      createMenuItem(
        'add', 
        'New', 
        'add', 
        createButton.onCreateClick,
        false,
        {
          bg: "#ef4444", // Red background
          text: "#ffffff" // White text
        }
      )
    );
  }

   

  // if (handleOnFilter) {
  //   menuItems.push(
  //     createMenuItem(
  //       'filter', 
  //       'Filter', 
  //       'filter', 
  //       handleOnFilter, 
  //       isFilterActive,
  //       {
  //         bg: "#ffffff", // Blue background
  //         text: "#000000" // White text
  //       }
  //     )
  //   );
  // }

  if (handleOnPrint) {
    menuItems.push(
      createMenuItem(
        'print', 
        'Print', 
        'print', 
        handleOnPrint,
        false,
        {
          bg: "#10b981", // Green background
          text: "#ffffff" // White text
        }
      )
    );
  }

  if (handleOnPark) {
    menuItems.push(
      createMenuItem(
        'parked', 
        'Parked', 
        'parked', 
        handleOnPark,
        false,
        {
          bg: "#f59e0b", // Amber background
          text: "#ffffff" // White text
        }
      )
    );
  }

  if (filterButton?.filterButton) {
    menuItems.push(
      createMenuItem(
        'help', 
        'Help', 
        'help', 
        filterButton.onFilterClick,
        false,
        {
          bg: "#8b5cf6", // Purple background
          text: "#ffffff" // White text
        }
      )
    );
  }

  if (handleOnExport) {
    menuItems.push(
      <div key="export" className="w-full px-4 py-2">
        <ExportButton
          onExport={(value) => {
            handleOnExport(value);
            setShowFloatingMenu(false);
          }}
          isCompact={true}
          className="w-full"
          style={{
            backgroundColor: "#6366f1",
            color: "#ffffff"
          }}
        />
      </div>
    );
  }

  // if (handleRemoveBtnClick) {
  //   menuItems.push(
  //     createMenuItem(
  //       'remove', 
  //       'Remove', 
  //       'remove', 
  //       handleRemoveBtnClick,
  //       false,
  //       {
  //         bg: "#dc2626", // Dark red background
  //         text: "#ffffff" // White text
  //       }
  //     )
  //   );
  // }

  // if (options?.option) {
  //   menuItems.push(
  //     createMenuItem(
  //       'options', 
  //       'Options', 
  //       'option', 
  //       options.onOptionClick,
  //       false,
  //       {
  //         bg: "#6b7280", // Gray background
  //         text: "#ffffff" // White text
  //       }
  //     )
  //   );
  // }

  // if (handleBack) {
  //   menuItems.push(
  //     createMenuItem(
  //       'back', 
  //       'Back', 
  //       'remove', 
  //       handleBack,
  //       false,
  //       {
  //         bg: "#6b7280", // Gray background
  //         text: "#ffffff" // White text
  //       }
  //     )
  //   );
  // }

  return menuItems;
};
  return (
    <>
      <div
        className={` bg-gray-soft-gradient h-screen flex flex-col overflow-hidden `}
      >
        {/* Header */}
        {header && (
          <div
            className={`flex-none ${isCompress && "shadow-[0_6px_12px_rgba(0,0,0,0.15)]"
              } ${!mobileView && !isCompress && "px-3 pt-3"}`}
          >
            <div className="relative z-10">
              <div
                className={`bg-white/60 ${isCompress || mobileView ? "" : "rounded-t-2xl"
                  } border border-gray-100 ${tabs.length > 0 && mobileView ? "px-4 pt-4" : "p-4"}`}
              >
                <div className="flex md:flex-row items-start justify-between gap-4">
                  {/* Left Side - Title and Stats */}
                  <div className="min-w-0 flex-1">
                    <h1 className="text-2xl font-bold text-gray-800 flex items-start">
                      {mobileView && !handleRemoveBtnClick && (
                        <span
                          className="w-5 mt-[7px] mr-5 text-(--tab-gray) flex-shrink-0 cursor-pointer"
                          onClick={() => {
                            setOpenMenuDrawer(true);
                          }}
                        >
                          <Icon type={"menu"} />
                        </span>
                      )}
                        {mobileView && handleRemoveBtnClick && (
                        <span
                          className="w-8  mr-5 text-(--tab-gray) flex-shrink-0 cursor-pointer"
                          onClick={() => {
                            handleRemoveBtnClick()
                          }}
                        >
                          <Icon type={"back"} />
                        </span>
                      )}
                      {(iconType && !mobileView) && (
                        <span className="bg-indigo-100 text-indigo-600 p-2 rounded-lg mr-3 w-8 flex-shrink-0">
                          <Icon type={iconType} />
                        </span>
                      )}
                  <span className={`flex-1   ${isMobileView() ? "whitespace-normal" :"whitespace-nowrap"}`}>
  {title}
</span>
                    </h1>
                    {!isCompress && !mobileView && title && (
                      <p className="text-gray-500 mt-1 ml-11.5  whitespace-nowrap">
                        {subTitle
                          ? subTitle
                          : `Manage and view all your ${title.toLowerCase()}`}
                      </p>
                    )}
                  </div>

                  {/* Right Side - Search and Actions */}
                  <div
                    className={`${mobileView ? "flex-shrink-0" : "w-full md:w-auto"
                      } flex flex-col sm:flex-row ${mobileView ? "" : "gap-5"}`}
                  >
                    {/* Search Bar */}
                    {!isCompress && !mobileView && customButtons?.length > 0 && customButtons?.map((btn, index) => (
                      <div key={index} className="flex-1">
                        {btn}
                      </div>
                    ))}
                    {!isCompress && !mobileView && (
                      <div className={`${mobileView ? "w-full" : "w-sm"} `}>
                        {search.searchBar && (
                          <div className="flex space-x-5">
                            <Searchbar
                              value={search.value}
                              onChange={search.onSearchChange}
                              placeholder={search.placeholder || "Search..."}
                              handleFilterClick={search.handleFilterClick}
                              hideFilter={search.hideFilter}
                              hideRefresh={search.hideRefresh}
                              handleRefreshClick={search.handleRefreshClick}
                              isFilterActive={search.isFilterActive}
                            />
                          </div>
                        )}
                      </div>
                    )}

                    {/* Tabs for desktop */}
                    {tabs.length > 0 && !mobileView && (
                      <div className="flex rounded-lg border border-gray-200 overflow-hidden bg-gray-50 mr-3 flex-shrink-0">
                        {tabs.map((tab) => (
                          <button
                            key={tab.value}
                            onClick={() => onTabChange(tab.value)}
                            className={`cursor-pointer px-4 py-2 h-[34px] text-sm font-medium transition-all duration-200 min-w-[90px] ${activeTab === tab.value
                                ? "bg-indigo-600 text-white"
                                : "bg-transparent text-gray-600 hover:bg-gray-100"
                              }`}
                          >
                            <div className="flex items-center whitespace-nowrap justify-center gap-2">
                              <span>{tab.label}</span>
                              {tab.count !== undefined && (
                                <span
                                  className={`px-2 py-0.5 text-xs rounded-full ${activeTab === tab.value
                                      ? "bg-white text-indigo-600"
                                      : "bg-gray-200 text-gray-600"
                                    }`}
                                >
                                  {tab.count}
                                </span>
                              )}
                            </div>
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Filter Button */}
                    <div className="flex gap-5 ml-auto flex-shrink-0">
                     
                      {!mobileView || !hasMultipleButtons ? (
                        <>
                          {handleOnRefresh && (
                            <IconButton
                              onClick={handleOnRefresh}
                              infoText={"Refresh"}
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <Icon type="refresh"></Icon>
                            </IconButton>
                          )}
                          {handleBack && (
                            <IconButton
                              onClick={handleBack}
                              infoText={"Back"}
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <Icon type="remove"></Icon>
                            </IconButton>
                          )}
                          {handleOnFilter && (
                            <IconButton
                              onClick={handleOnFilter}
                              infoText={"filter"}
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <div className="relative">
                                <Icon type="filter" />
                                {isFilterActive && (
                                  <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
                                    <span className="relative flex h-2 w-2">
                                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                                      <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
                                    </span>
                                  </span>
                                )}
                              </div>
                            </IconButton>
                          )}
                          {handleOnPrint && (
                            <IconButton
                              onClick={handleOnPrint}
                              infoText={"Print"}
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <Icon type="print"></Icon>
                            </IconButton>
                          )}
                          {createButton.createButton && !isMobileView() && (
                            <span>
                              <Button
                                type="primary"
                                px="px-4"
                                onClick={createButton.onCreateClick || (() => { })}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5 mr-2"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 4v16m8-8H4"
                                  />
                                </svg>
                                {createButton.createButtonText}
                              </Button>
                            </span>
                          )}
                          {handleOnPark && (
                            <IconButton
                              onClick={handleOnPark || (() => { })}
                              label="options"
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                              infoText={"Parked Transaction"}
                              tooltipWidth={"150px"}
                            >
                              <Icon type="parked"></Icon>
                            </IconButton>
                          )}

                           {options?.option && (
                        <IconButton
                          onClick={options.onOptionClick || (() => { })}
                          label="options"
                          bgColor="#F5F5F5"
                          textColor="#5e5e5e"
                          newhover={true}
                          infoText={"Option"}
                        >
                          <Icon type="option"></Icon>
                        </IconButton>
                      )}

                          {filterButton.filterButton && (
                            <IconButton
                              onClick={filterButton.onFilterClick || (() => { })}
                              label="help"
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <Icon type="help"></Icon>
                            </IconButton>
                          )}
                          {handleOnExport && (
                            <ExportButton
                              onExport={(value) => {
                                handleOnExport(value);
                              }}
                            />
                          )}
                          {handleRemoveBtnClick && (
                            <span
                              className="hidden md:block lg:block w-7 p-0 text-right text-(--list-item-gray) hover:text-gray-900 cursor-pointer mt-1.5 flex-shrink-0"
                              onClick={handleRemoveBtnClick}
                            >
                              <Icon type={"remove"} />
                            </span>
                          )}
                        </>
                      ) : (
                        // In mobile view with multiple buttons, show only the first 2 buttons
                        <>
                          {handleOnRefresh && (
                            <IconButton
                              onClick={handleOnRefresh}
                              infoText={"Refresh"}
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <Icon type="refresh"></Icon>
                            </IconButton>
                          )}
                          {handleOnFilter && (
                            <IconButton
                              onClick={handleOnFilter}
                              infoText={"filter"}
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <div className="relative">
                                <Icon type="filter" />
                                {isFilterActive && (
                                  <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
                                    <span className="relative flex h-2 w-2">
                                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                                      <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
                                    </span>
                                  </span>
                                )}
                              </div>
                            </IconButton>
                          )}
 {options?.option && (
                        <IconButton
                          onClick={options.onOptionClick || (() => { })}
                          label="options"
                          bgColor="#F5F5F5"
                          textColor="#5e5e5e"
                          newhover={true}
                          infoText={"Option"}
                        >
                          <Icon type="option"></Icon>
                        </IconButton>
                      )}
                          {handleBack && (
                            <IconButton
                              onClick={handleBack}
                              infoText={"Remove"}
                              bgColor="#F5F5F5"
                              textColor="#5e5e5e"
                              newhover={true}
                            >
                              <Icon type="remove"></Icon>
                            </IconButton>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Search bar for mobile/compress view */}
                {(isCompress || mobileView) && (
                  <div className="mt-5">
                    <div className="">
                      {search.searchBar && (
                        <div className="flex space-x-5">
                          <Searchbar
                            value={search.value}
                            onChange={search.onSearchChange}
                            placeholder={search.placeholder || "Search..."}
                            handleFilterClick={search.handleFilterClick}
                            hideFilter={search.hideFilter}
                            hideRefresh={search.hideRefresh}
                            handleRefreshClick={search.handleRefreshClick}
                            isFilterActive={search.isFilterActive}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {tabs.length > 0 && mobileView && (
                  <div className="">
                    <Tab
                      isTransparentBg={true}
                      tabs={tabs.map(tab => ({
                        name: tab.value,
                        label: tab.label
                      }))}
                      activeTab={activeTab}
                      onTabChange={onTabChange}
                      showBorder={true}
                      isNowrap={true}
                      mt={"mt-0"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {customHeader && <span>{customHeader}</span>}

        {/* Main Content */}
        <div
          className={`flex-grow  ${!mobileView && !isCompress && "px-3 "
            }  overflow-hidden `}
        >
          {children}

          {/* Floating action buttons for mobile */}
          {/* {isMobileView() && createButton.createButton && (
            <div className={`fixed ${showFloatingButton ? "bottom-[80px]" : "bottom-5"} right-6 rounded-lg shadow-lg z-10`}>
              <IconButton
                size="large"
                onClick={createButton.onCreateClick || (() => { })}
                type="secondary"
              >
                <span className="text-black"><Icon type="add" /></span>
              </IconButton>
            </div>
          )} */}

{showFloatingButton && (
  <>
    {/* Overlay */}
    {showFloatingMenu && (
      <div 
        className="fixed inset-0 bg-black/70 z-10"
        onClick={() => setShowFloatingMenu(false)}
      />
    )}
    
    <div className="fixed bottom-5 right-6 z-20" ref={floatingMenuRef}>
      {/* Floating Menu Items */}
      {showFloatingMenu && (
        <div className="absolute bottom-16 right-0 mb-2 overflow-hidden animate-slide-up">
          <div className="py-2 shadow-xl">
            <FloatingMenuItems />
          </div>
        </div>
      )}

      {/* Main Floating Button */}
      <IconButton
        size="large"
        onClick={() => {
          const buttonCount = countHeaderButtons();
           console.log("buttoncount",buttonCount);
          // If only create button exists (count = 1 and it's the create button)
          if (buttonCount === 1 && createButton.createButton) {
            // Directly execute the create action
            createButton.onCreateClick();
          } else {
            // Multiple buttons or no create button - toggle menu as normal
            setShowFloatingMenu(!showFloatingMenu);
          }
        }}
        type="primary"
        bordernone={true}
        className={`transition-transform duration-200 ${showFloatingMenu ? 'rotate-45' : ''}`}
      >
        <span className="text-white">
          <Icon type={showFloatingMenu ? "remove" : countHeaderButtons() === 1 && createButton.createButton ? "add": "option"} />
        </span>
      </IconButton>
    </div>
  </>
)}
        </div>

        {/* Footer */}
        {footer && !mobileView && (
          <div
            className={`flex-none ${isCompress ? "shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]" : "px-3"
              }  mb-3 backdrop-blur-sm `}
          >
            {footer}
          </div>
        )}

        {hideFooter && !mobileView && (
          <div className="flex-none px-3 mb-3 backdrop-blur-sm bg-white/70 p-2 rounded-b-xl border border-gray-100 mx-3"></div>
        )}
      </div>

      {/* Mobile Menu Drawer */}
      {openMenuDrawer && (
        <MobileMenu
          isOpen={openMenuDrawer}
          onClose={() => setOpenMenuDrawer(false)}
        />
      )}
    </>
  );
};

export default DataViewPage;
